import * as RouterDom from "react-router-dom";

// The desktop profile's tabs under the NILx rate card (spec B1):
// Performance (default), Visibility and Value. The key is the phone tabs'
// ?tab= key (mobile/ProfileTabsMobile), so a link or a rotate keeps the
// tab; anything else there (overview, about, nothing) opens Performance.
// The tablist is named apart from the phone one ("Profile sections").
//
// A module of its own: the pages read the tab here, and one suite
// factory-mocks ProfileBody with a fixed list of exports.

export const DESKTOP_PROFILE_TABS = [
  { key: "performance", label: "Performance" },
  { key: "visibility", label: "Visibility" },
  { key: "value", label: "Value" },
];
export const DEFAULT_DESKTOP_TAB = "performance";
export const DESKTOP_TABS_LABEL = "Profile views";

export const desktopTabFor = (value) => (DESKTOP_PROFILE_TABS.some((t) => t.key === value) ? value : DEFAULT_DESKTOP_TAB);

// The router's search params where the page sits in a router (the app
// always does); a page rendered without one keeps the tab in ProfileBody.
const NO_PARAMS = new URLSearchParams();
const noSearchParams = () => [NO_PARAMS, null];
const useRouterSearchParams = typeof RouterDom.useSearchParams === "function" ? RouterDom.useSearchParams : noSearchParams;
const useInRouter = typeof RouterDom.useInRouterContext === "function" ? RouterDom.useInRouterContext : () => false;

// The pages' desktop tab, kept in ?tab= (replacing the history entry, as
// the phone tabs do): [tab, setTab]. setTab is null without a router; the
// pages pass both to ProfileBody (tab, onTabChange).
export const useProfileTabParam = () => {
  const inRouter = useInRouter();
  // A page never moves in or out of its router, so the hooks run in the
  // same order on every render.
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [params, setParams] = inRouter ? useRouterSearchParams() : noSearchParams();
  const tab = desktopTabFor(params.get("tab"));
  const setTab = setParams
    ? (next) =>
        setParams(
          (prev) => {
            const out = new URLSearchParams(prev);
            out.set("tab", desktopTabFor(next));
            return out;
          },
          { replace: true },
        )
    : null;
  return [tab, setTab];
};
